
////////////////////////////Running Code::::::::::::::::::::::::::::::::

import React, { useEffect, useState, memo } from 'react'

import classes from './Profile.module.scss';
import BreadCrumb from './../../utilities/BreadCrumb/BreadCrumb'
import { toast } from 'react-hot-toast';
import axios from 'axios';
const Profile = () => {
    const [fetchUserID, setFetchUserID] = useState("");
    const [data, setData] = useState([])

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        const fetchedData = JSON.parse(localStorage.getItem('data'));

            if (userID && fetchedData) {
                setFetchUserID(userID);
                setData(fetchedData);
            }
    }, []);
    const [qrUrl, setQrUrl] = useState('');
    useEffect(() => {
        axios.get(window.env.APP_URL+"/genqr.php"+
                    "?name="+encodeURIComponent(data.empname)+
                    "&mobile="+encodeURIComponent(data.mobile)+
                    "&email="+encodeURIComponent(data.email)+
                    "&name="+encodeURIComponent(data.empname)+
                    "&empid="+encodeURIComponent(data.empid)+
                    "&desig="+encodeURIComponent(data.desig)+
                    "&qr=true"
                )
                .then(() => {
                    setQrUrl(window.env.APP_URL+"/qrcode/"+data.empid+".png");
                    console.log(qrUrl);
                })
                .catch(error => console.error('Request failed:', error));
    }, [data]);
    useEffect(()=> console.log(qrUrl),[qrUrl]);

    return (
        <>
            <BreadCrumb name="e-Visiting Card" />
            <div className={classes.Profile}>
                <div className={classes.RowDiv}>
                    <div className={classes.ColumnDiv}>
                        <img className={classes.LogoImg} src={window.env.APP_URL+"/logo-with-text.png"} alt="Logo" />
                        <img src={qrUrl} style={{width:"30dvw"}} alt="QR Code" />
                    </div>
                    <div className={classes.ColumnDiv}>
                        <img className={classes.ProfileImg} src={`data:image/jpeg;base64,${data.photo}`} alt="User" />
                        <p className={classes.text}>{data.empname}</p>
                        <p className={classes.text}>{data.desig}</p>
                        <p className={classes.text}>{data.mobile}</p>
                        <p className={classes.text}>{data.email}</p>
                        <p className={classes.text}>web: ncrtc.in</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile


///////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////Testing Code for do not show the e-visiting card for os employee:::::::::::::::::::::::::::::::://////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useEffect, useState, memo } from 'react';
// import classes from './Profile.module.scss';
// import BreadCrumb from './../../utilities/BreadCrumb/BreadCrumb';
// import { toast } from 'react-hot-toast';
// import axios from 'axios';

// const Profile = () => {
//     const [fetchUserID, setFetchUserID] = useState("");
//     const [data, setData] = useState({});
//     const [qrUrl, setQrUrl] = useState('');

//     useEffect(() => {
//         const userID = localStorage.getItem('userID');
//         const fetchedData = JSON.parse(localStorage.getItem('data'));

//         if (userID && fetchedData) {
//             setFetchUserID(userID);
//             setData(fetchedData);
//         }
//     }, []);

//     useEffect(() => {
//         if (data && (data.emp_type === 'P' || data.emp_type === 'C' || data.emp_type === 'D' || data.emp_type === 'R' || data.emp_type === 'RE')) {
//             axios.get(
//                 `${window.env.APP_URL}/genqr.php` +
//                 `?name=${encodeURIComponent(data.empname)}` +
//                 `&mobile=${encodeURIComponent(data.mobile)}` +
//                 `&email=${encodeURIComponent(data.email)}` +
//                 `&empid=${encodeURIComponent(data.empid)}` +
//                 `&desig=${encodeURIComponent(data.desig)}` +
//                 `&qr=true`
//             )
//             .then(() => {
//                 setQrUrl(`${window.env.APP_URL}/qrcode/${data.empid}.png`);
//             })
//             .catch(error => console.error('Request failed:', error));
//         }
//     }, [data]);

//     useEffect(() => console.log(qrUrl), [qrUrl]);

//     const allowedEmpTypes = ['P', 'C', 'D' ,'R','RE'];     ////list of employee types who are allowed to see an e-visiting card.

//     return (
//         <>
//             <BreadCrumb name="e-Visiting Card" />
//             <div className={classes.Profile}>
//                 {allowedEmpTypes.includes(data.emp_type) ? (
//                     <div className={classes.RowDiv}>
//                         <div className={classes.ColumnDiv}>
//                             <img className={classes.LogoImg} src={`${window.env.APP_URL}/logo-with-text.png`} alt="Logo" />
//                             <img src={qrUrl} style={{ width: "30dvw" }} alt="QR Code" />
//                         </div>
//                         <div className={classes.ColumnDiv}>
//                             <img
//                                 className={classes.ProfileImg}
//                                 src={`data:image/jpeg;base64,${data.photo}`}
//                                 alt="User"
//                             />
//                             <p className={classes.text}>{data.empname}</p>
//                             <p className={classes.text}>{data.desig}</p>
//                             <p className={classes.text}>{data.mobile}</p>
//                             <p className={classes.text}>{data.email}</p>
//                             <p className={classes.text}>web: ncrtc.in</p>
//                         </div>
//                     </div>
//                 ) : (
//                     <p className={classes.text}>E-Visiting Card not available for this employee type.</p>
//                 )}
//             </div>
//         </>
//     );
// };

// export default memo(Profile);



















